// extracted by mini-css-extract-plugin
export default {"root":"DueDiligenceSettingsForm_root__NQCCY","switches":"DueDiligenceSettingsForm_switches__gPjr6"};